







import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class ZoomControls extends Vue {

  @Prop() cloud: HTMLElement;

  get scaleCloud(): number {
    return this.$store.state.rhizome.scaleCloud;
  }

  set scaleCloud(value: number) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'scaleCloud', value });
  }

  mounted() {
    window.addEventListener('mousewheel', this.scrollAction);
    window.addEventListener('DOMMouseScroll', this.scrollAction);
  }

  scrollAction(event) {
    let delta = 0;

    if (!event) event = window.event;
    if (event.wheelDelta) {
      delta = event.wheelDelta/120;
    }
    else if (event.detail) {
      delta = -event.detail/3;
    }

    this.zoomCloud(delta);
  }

  zoomCloud(delta: number) {
    if (delta) {
      if ((this.scaleCloud <= 0.2 && delta < 0) || (this.scaleCloud >= 1.5 && delta > 0)) return;

      let transformParts = this.cloud.style.transform.split(' ');
      const x = +transformParts[0].replace('translateX(', '').replace('px)', '');
      const y = +transformParts[1].replace('translateY(', '').replace('px)', '');

      const oldScale = this.scaleCloud;
      this.scaleCloud += delta * 0.1;

      const ww = window.innerWidth;
      const wh = window.innerHeight;

      const ow = 10000;
      const oh = 10000;

      const cxFac = (-x + ww / 2) / (ow * oldScale);
      const cyFac = (-y + wh / 2) / (oh * oldScale);

      const cx = cxFac * ow * this.scaleCloud;
      const cy = cyFac * oh * this.scaleCloud;

      const tx = ww / 2 - cx;
      const ty = wh / 2 - cy;

      this.cloud.style.transform = `translateX(${tx}px) translateY(${ty}px) scale(${this.scaleCloud})`;
    }
  }

  destroyed() {
    window.removeEventListener('mousewheel', this.scrollAction);
    window.removeEventListener('DOMMouseScroll', this.scrollAction);
  }
}
